import { useEffect, useRef, useState } from "react";
import api from "../api.js";
import { useT } from "../i18n/LanguageContext.js";

export default function Review({ addressId, address, selection, onRedirect, backToVehicle }) {
  const t = useT();
  const [submitting, setSubmitting] = useState(false);
  const [err, setErr] = useState("");
  const alertRef = useRef(null);

  useEffect(()=>{ if (err && alertRef.current) alertRef.current.focus(); }, [err]);

  const handleConfirm = async () => {
    setErr(""); setSubmitting(true);
    try{
      await api.post("/selection", {
        addressId,
        ProductType: selection.ProductType || null,
        PartNumber: selection.PartNumber || null,
        year: selection.year,
        make: selection.make,
        model: selection.model,
        submodel: selection.submodel,
      });
      onRedirect();
    }catch{
      setErr(t("alerts.recordSelectionFail"));
      setSubmitting(false);
    }
  };

  if (!address || !selection) return null;

  return (
    <div>
      <h2 style={{ marginTop: 0 }}>{t("step3Title")}</h2>

      {err && <div ref={alertRef} role="alert" className="alert" tabIndex="-1">{err}</div>}

      <section className="card" style={{ marginBottom: 16 }}>
        <h3 style={{ marginTop: 0 }}>{t("sections.address")}</h3>
        <div className="grid-2">
          <div className="field"><label>{t("field.name")}</label><div>{address.name}</div></div>
          <div className="field"><label>{t("field.email")}</label><div>{address.email}</div></div>
          <div className="field"><label>{t("field.phone")}</label><div>{address.phone}</div></div>
          <div className="field"><label>{t("field.postal")}</label><div>{address.postalCode}</div></div>
          <div className="field" style={{ gridColumn: "1 / -1" }}><label>{t("field.street")}</label><div>{address.address}</div></div>
          <div className="field"><label>{t("field.city")}</label><div>{address.city}</div></div>
          <div className="field"><label>{t("field.province")}</label><div>{address.province}</div></div>
        </div>
      </section>

      <section className="card" style={{ marginBottom: 16 }}>
        <h3 style={{ marginTop: 0 }}>{t("sections.vehicle")}</h3>
        <div className="grid-2">
          <div className="field"><label>{t("field.year")}</label><div>{selection.year}</div></div>
          <div className="field"><label>{t("field.make")}</label><div>{selection.make}</div></div>
          <div className="field"><label>{t("field.model")}</label><div>{selection.model}</div></div>
          <div className="field"><label>{t("field.submodel")}</label><div>{selection.submodel}</div></div>
        </div>
      </section>

      <section className="card" style={{ marginBottom: 16 }}>
        <h3 style={{ marginTop: 0 }}>{t("sections.chosenPart")}</h3>
        <div className="grid-2">
            <div className="field">
            <label>{t("field.productType")}</label>
            <div>{selection.ProductType}</div>
            </div>

            <div className="field">
            <label>{t("field.partNumber")}</label>
            <div>{selection.PartNumber}</div>
            </div>

            <div className="field">
            <label>{t("field.availability")}</label>
            <div>{selection.Availability}</div>
            </div>

            {/* 🆕 Fitment Notes */}
            {selection.FitmentNotes && (
            <div className="field" style={{ gridColumn: "1 / -1" }}>
                <label>{t("field.fitmentNotes")}</label>
                <div
                style={{
                    whiteSpace: "pre-wrap",
                    backgroundColor: "var(--bg-muted)",
                    padding: "8px 12px",
                    borderRadius: "8px",
                    lineHeight: 1.5,
                }}
                >
                {selection.FitmentNotes}
                </div>
            </div>
            )}
        </div>
        </section>

      <div className="status" role="status" aria-live="polite">
        {submitting ? t("status.submitting") : ""}
      </div>

      <div className="btn-row">
        <button className="btn ghost" type="button" onClick={backToVehicle} disabled={submitting} aria-disabled={submitting}>
          {t("btn.editVehicle")}
        </button>
        <button className="btn primary" type="button" onClick={handleConfirm} disabled={submitting} aria-disabled={submitting}>
          {submitting ? t("status.submitting") : t("btn.confirm")}
        </button>
      </div>
    </div>
  );
}
